import { Component, NgModule, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ICellRendererParams } from 'ag-grid-community';
import { AlertDialogComponent } from 'src/app/alert-dialog/alert-dialog.component';
import { PeopleDropDownComponent } from 'src/app/people-drop-down/people-drop-down.component';
import { messages } from 'src/app/popUpMessages/messages';
import { serverMessage } from 'src/app/popUpMessages/serverMessage';
import { CategorizationService } from 'src/app/services/categorization.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { HelpService } from 'src/app/services/help.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { MenuService } from 'src/app/services/menu.service';
import { ProjectService } from 'src/app/services/project.service';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { ToasterService } from 'src/app/services/toaster.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { CheckboxComponent } from '../../admin/checkbox/checkbox.component';
import { EditDeleteComponent } from 'src/app/grid/button-edit/edit-delete/edit-delete.component';
import { ConfigurationAccessComponent } from '../ConfigurationAccess/configuration-access/configuration-access.component';
import { AssemblyForAccessComponent } from '../AssemblyForAccess/assembly-for-access/assembly-for-access.component';
import { ProjectPeopleDropdownComponent } from '../project-people-dropdown/project-people-dropdown.component';
import { MatDialogModule } from '@angular/material/dialog';
import { tcAuthorizationAccess } from 'src/app/models/tcAuthorizationAccess';
import { DeleteiconComponent } from '../../deleteIconNormalGrid/deleteicon.component';
import { debug } from 'console';


@Component({
  selector: 'app-access-mangment-config',
  templateUrl: './access-mangment-config.component.html',
  styleUrls: ['./access-mangment-config.component.css']
})


export class AccessMangmentConfigComponent implements OnInit {

  public rowData: any = [];
  public defaultColDef: any;
  public columnDefs: any = [];
  public gridApi: any;
  public gridColumnApi: any;
  public domLayout: any;
  public rowHeight: any;
  public headerHeight: any;
  public alertErrorBox = [];
  public errorMessage = []
  public loggedInUser: any;
  public getResponse: any;
  public frameworkComponents: any;
  public idGenerated: number = 1;
  public hasUnsavedChanges: boolean = false;
  public submitted: boolean = false;
  public isEditable: boolean = true;

  public sizeToFitRefresh: number = 0;
  public showGrid = false;

  public businessAreaId: number;
  public businessLineId: number;
  public userInOrg: any;
  public allUserList: any;
  public modifiedConfigurationRows = []
  projectSubmitterId: any;

  submitResponse: any;
  receivedData: any;
  totalDataCount: any;
  projectId: any;
  moduleId: number = 4;
  objData: any;
  userDetails: [];
  configurationData: any;
  configurationFromLocal: any;
  allConfigurations: any;
  lockVisible: boolean;
  isAdmin: boolean;
  status: any = [];
  options: any;
  public Standdata: any = [];
  openPopup: any;
  // public agGridContext = {
  //   onProductDataUpdate: (updatedProductData: any[], configId: any, rowIndex: number) => this.onProductDataUpdate(updatedProductData, configId, rowIndex)
  // };
  TCProductData: any[];
  assemblies: any;
  selectedValues: any;
  fromPage: any;
  // route: any;
  constructor(

    private toast: ToasterService,
    private sharedService: SharedServiceService,
    private configurationService: ConfigurationService,
    private projectService: ProjectService,
    public dialog: MatDialog,
    private localStorageService: LocalStorageService,
    private router: Router,
    private menuService: MenuService,
    private userService: UserInfoService,
    private helpService: HelpService,
    private catService: CategorizationService,
    private route: ActivatedRoute,

  ) {
    //this.popupParent = document.querySelector('body');
    this.frameworkComponents = { contactDropdownEditor: PeopleDropDownComponent, userDropdownEditor: ProjectPeopleDropdownComponent };
  }






  ngOnInit() {

    this.sharedService.getProjectIdAndTitle();

    this.route.queryParams.subscribe(params => {
      this.fromPage = params['from'];
    });

    this.projectId = this.localStorageService.get("projectId");
    this.sharedService.accessDeleteRow.subscribe(data => {
   
      this.hasUnsavedChanges = true;
      data.IsRemoved = true;

      if (data.ProjectId != null || data.UserId != null || data.configurationId != null) {
        const rowsToRemove = [];
        this.gridApi.forEachNode(node => {
          if (
            node.data.ProjectId == data.ProjectId &&
            node.data.ConfigurationId == data.ConfigurationId &&
            node.data.UserId == data.UserId &&
            node.data.Assemblies == data.Assemblies
          ) {
            rowsToRemove.push(node.data);
          }
        });
        this.gridApi.applyTransaction({ remove: rowsToRemove });
      }
    })
    this.objData = {
      projectId: this.projectId,
      moduleId: this.moduleId
    }
    if (this.projectId != null) {
      this.projectService.getTCData(this.projectId).subscribe((data: any) => {
        if (data.StatusCode == 200) {

          this.businessAreaId = data.Data.BusinessAreaId;
          this.businessLineId = data.Data.BusinessLineId;
          this.sharedService.loggedInUser.subscribe((user: any) => {
            if (user) {
              this.showGrid = true
              this.userService.getUserList(this.businessAreaId, this.businessLineId).subscribe((d) => {
                this.allUserList = d;
                this.userInOrg = this.allUserList.find(u => u.Email == user.Email);
                if (this.userInOrg != undefined) {
                  this.projectSubmitterId = this.userInOrg.UserId;

                  let userIsFinancialController = data.Data.FinancialControllerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsFinancialControllerProxy = data.Data.FinancialControllerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  // let userIsSubmitter = data.Data.SubmitterId.split(',').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProductManager = data.Data.ProductManagerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProductManagerProxy = data.Data.ProductManagerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProjectManager = data.Data.ProjectManagerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProjectManagerProxy = data.Data.ProjectManagerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsServiceManager = data.Data.ServiceManagerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsServiceManagerProxy = data.Data.ServiceManagerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProcurementEngineer = data.Data.ProcurementEngineerIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsProcurementEngineerproxy = data.Data.ProcurementEngineerProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsSystemArchitect = data.Data.SystemArchitectIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsSystemArchitectProxy = data.Data.SystemArchitectProxyIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);
                  let userIsWatchList = data.Data.WatchListIDs.split(';').map(s => Number(s.trim())).includes(this.userInOrg.UserId);

                  if (userIsFinancialController || userIsFinancialControllerProxy || this.userInOrg.TargetRoleId == 1) {
                    this.lockVisible = true;
                  }

                  if (this.userInOrg.TargetRoleId == 1) {
                    this.isAdmin = true;
                  }

                  if (this.userInOrg.TargetRoleId == 1 || this.userInOrg.TargetRoleId == 2) {
                    this.isEditable = true;
                  }
                  else if (this.userInOrg.TargetRoleId == 3) {
                    if (data.Data.SubmitterId == this.userInOrg.UserId || userIsFinancialController || userIsFinancialControllerProxy
                      || userIsProductManager || userIsProductManagerProxy || userIsProjectManager || userIsProjectManagerProxy
                      || userIsServiceManager || userIsServiceManagerProxy || userIsProcurementEngineer || userIsProcurementEngineerproxy
                      || userIsSystemArchitect || userIsSystemArchitectProxy || userIsWatchList
                    ) {
                      this.isEditable = true;
                    }
                    else {
                      this.isEditable = false;
                    }
                  }
                }

                this.loadData();
              })
            }
          })
        }
      });
    } else {
      this.businessAreaId = this.businessLineId = 0;
    }


  }



  loadData() {
    this.showGrid = false;
    this.configurationFromLocal = this.localStorageService.get("configuration");
    this.configurationService.GetTCAuthorizationAccess(this.projectId, this.businessAreaId, this.businessLineId).subscribe(d => {
      this.showGrid = true;
      let errorMsgeFromBack = d.Data.Message;
      if (d.StatusCode == 200) {
        this.rowData = d.Data;

        this.rowData.forEach(data => {
          // data["IsAdmin"] = this.
          data["IsEditable"] = this.isEditable
          //data["LockVisible"] = this.lockVisible
        })

        // this.rowData = this.configurationData;
        // // console.log(this.businessAreaId, this.businessLineId)
        // this.rowData.forEach(data => {
        //   data["businessAreaId"] = this.businessAreaId
        //   data["businessLineId"] = this.businessLineId

        // })
        if (this.configurationFromLocal != null) {
          this.hasUnsavedChanges = true;
          // if (this.configurationFromLocal.configurationId == 0)
          //   this.addNewRow();
          // else {
          //   let row = this.configurationData.find(x => x.Id == this.configurationFromLocal.configurationId);
          //   this.modifiedConfigurationRows.push(row);
          // }
        }
        this.loadGrid();
      } else {
        //Show errorCode and errorMessage in the UI
        let errorContainer = [
          { [serverMessage.serverErrorMessage]: serverMessage.serverErrorHeader },
          { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
        ]
        this.openAlertDialog(errorContainer);
      }
    });
  }

  loadGrid() {
    let regex = new RegExp(/\^s*$/);
    this.columnDefs = [

      {
        headerName: 'Teams',
        field: "UserName",
        headerTooltip: "Teams",
        tooltipField: "Teams",
        width: 150,
        editable: true,
        singleClickEdit: true,
        cellEditor: "userDropdownEditor",
        cellEditorParams: {
          ProjectId: this.projectId, // Pass the projectId here
          businessAreaId: this.businessAreaId,
          businessLineId: this.businessLineId
        },
        cellStyle: (params) => params.data.UserName == "" || params.data.UserName == null ? { borderLeft: "5px solid #a94442" } : { borderLeft: "" }
      },

      {
        headerName: "Org Code",
        headerTooltip: "Org Code",
        field: "OrgCode",
        editable: false,
        tooltipField: "OrgCode",
        width: 140,
        cellStyle: (params) => params.data.OrgCode == "" || params.data.OrgCode == null ? { borderLeft: "5px solid #a94442" } : { borderLeft: "" }
      },
      {
        headerName: "Read only",
        field: "IsReadAccess",
        tooltipField: "ReadOnly",
        headerTooltip: "ReadOnly",
        width: 100,
        cellRendererFramework: CheckboxComponent,

      },
      {
        headerName: "Read and write",
        field: "IsReadOrWriteAccess",
        tooltipField: "ReadandWrite",
        headerTooltip: "Read and Write",
        width: 100,
        cellRendererFramework: CheckboxComponent,

      },
      {
        headerName: "Configuration(s)",
        field: "ConfigurationName",
        tooltipField: "Configurations",
        headerTooltip: "Configurations",
        //width: 60,
        cellRenderer: dropdownTextRenderer,
        cellEditorFramework: ConfigurationAccessComponent,
        width: 150,
        singleClickEdit: true,
        editable: true,
        valueGetter: (params) => {
          if (params.data.ConfigurationName) {
            return params.data.ConfigurationName;
          }
          return params.data.ConfigurationName || '';
        },
        filter: true,
        cellStyle: (params) => params.data.ConfigurationName == "" || params.data.ConfigurationName == null ? { borderLeft: "5px solid #a94442" } : { borderLeft: "" }
      },
      {
        headerName: "Assembly group(s)",
        field: "Assemblies",
        tooltipField: "AssemblyGroup",
        headerTooltip: "AssemblyGroup",
        width: 150,
        cellRenderer: AssemblydropdownTextRenderer,
        cellEditorFramework: AssemblyForAccessComponent,
        editable: true,
        valueGetter: (params) => {
          if (Array.isArray(params.data.Assemblies)) {
            return params.data.Assemblies.map(a => a.AssemblyName).join(', ');
          }
          return '';
        },
        cellStyle: (params) => params.data.Assemblies == "" || params.data.Assemblies == null ? { borderLeft: "5px solid #a94442" } : { borderLeft: "" }
        // filter: 'agSetColumnFilter',
        // filterParams: {
        //   getValues: (params) => {
        //     console.log("hi")
        //     const allAssemblies = [];
        //     params.api.forEachNode(node => {
        //       console.log(node);
        //       if (Array.isArray(node.data.Assemblies)) {
        //         node.data.Assemblies.forEach(a => {
        //           if (a && a.AssemblyName) {
        //             allAssemblies.push(a.AssemblyName);
        //           }
        //         });
        //       }
        //     });
        //     console.log(allAssemblies);
        //     return Array.from(new Set(allAssemblies));
        //   }
        // }
      },

      {
        filter: false,
        //width: 350,
        headerName: 'Action',
        headerTooltip: "Action",

        cellRendererFramework: DeleteiconComponent,
        width: 100,
      },
    ];
    this.showGrid = true;
    this.defaultColDef = {
      filter: true,
      sortable: true,
      singleClickEdit: true,
      editable: false
    };
    this.domLayout = 'autoHeight';
    // this.rowData = [];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi
    this.sizeToFitRefresh = 1;
    // this shared service is emitted when the contact people picker is closed completly; it reset the grid data with the new data;
    this.sharedService.peoplePickerGridApi.subscribe(api => {
      this.gridApi = api
    })
  }

  onGridSizeChanged(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  onDisplayedColumnsChanged(event) {
    if (this.sizeToFitRefresh != 0) {
      this.gridApi.sizeColumnsToFit();
    }
  }



  onCellValueChanged(params) {
    // console.log("onCellValueChanged", params);
    this.hasUnsavedChanges = true;
    if (params.data.Id != 0) {
      let isPushed = false;
      if (this.modifiedConfigurationRows.length == 0) {
        this.modifiedConfigurationRows.push(params.data);
        isPushed = true;
      }
      else {
        this.modifiedConfigurationRows.forEach(row => {
          if (params.data.Id == row.Id) {
            isPushed = true;
          }
        })
      }
      if (!isPushed) {
        this.modifiedConfigurationRows.push(params.data);
      }
    }
    // console.log("modifiedConfigurationRows", this.modifiedConfigurationRows);
    if (this.hasDuplicateAccess()) {
      this.openAlertDialog([{ Duplicate: messages.DuplicateAccess }]);
      // params.node.setData(params.oldValue);
      // console.log(params.oldValue);
      // params.node.setDataValue(params.column.getColId(), params.oldValue);
    }
  }

  addNewUser() {
    this.alertErrorBox = [];
    let errorMessage = messages.cellEmptyErrorMesssage;
    let checkbox = messages.AccessCheckbox;
    let error = [];
    let lastRow = this.gridApi.getDisplayedRowAtIndex(this.gridApi.getDisplayedRowCount() - 1);

    if (lastRow != undefined) {
      let data = lastRow.data;

      if (data.UserName == "" || data.UserName == undefined) {
        error.push({ UserName: errorMessage })
      }
      if (data.OrgCode == "" || data.OrgCode == undefined) {
        error.push({ OrgCode: errorMessage })
      }
      if (data.IsReadAccess == null && data.IsReadOrWriteAccess == null || data.IsReadAccess == false && data.IsReadOrWriteAccess == false ||
        data.IsReadAccess == undefined && data.IsReadOrWriteAccess == undefined) {
        error.push({ ReadOnly: checkbox })
        error.push({ IsReadOrWriteAccess: checkbox })
      }
      if (data.ConfigurationName == " " || data.ConfigurationName == null) {
        error.push({ Configuration: errorMessage })
      }
      if (data.Assemblies == " " || data.Assemblies == null) {
        error.push({ AssemblyGroup: errorMessage })
      }
      if (error.length != 0) {
        this.openAlertDialog(error);
        return false;
      }
    }
    this.hasUnsavedChanges = true;
    this.alertErrorBox = [];


    this.gridApi.applyTransaction({
      add: [{
        Id: 0,
        UserName: null,
        OrgCode: null,
        IsReadAccess: null,
        IsReadOrWriteAccess: null,
        ConfigurationName: null,
        ConfigurationId: null,
        AssemblyGroup: null,
        AccessId: this.projectId,
        businessAreaId: this.businessAreaId,
        businessLineId: this.businessLineId,
        IsEditable: true,
        UserId: null,
      }]
    });
    //    this.idGenerated += 1;

  }

  openAlertDialog(error) {
    this.dialog.open(AlertDialogComponent, { data: error })
  }

  canDeactivate() {
    return this.hasUnsavedChanges;
  }

  onClickCancel() {
    this.hasUnsavedChanges = false;
    this.localStorageService.remove("configuration");
    this.router.navigate(["/tc-manageProject"]);
  }

  onClickBack() {
    this.hasUnsavedChanges = false;

    if (this.fromPage === 'ProjectPage') {
      this.router.navigate(["/tc-project"])
    } else if (this.fromPage === 'Configuration') {
      this.router.navigate(["/tc-configuration"])
    } else {
      this.router.navigate(["/tc-project"])
    }

  }

  onClickNext() {
    this.submit();
    // if (this.fromPage === 'ProjectPage') {
    //   this.router.navigate(["/tc-project"])
    // } else if (this.fromPage === 'Configuration') {
    //   this.router.navigate(["/tc-configuration"])
    // } else {
    //   this.router.navigate(["/tc-project"])
    // }
  }

  private hasDuplicateAccess(): boolean {
    const flattenedData: any[] = [];
    this.gridApi.forEachNode(node => {
      const assemblies = node.data.Assemblies || [];
      assemblies.forEach((assembly: any) => {
        let accessType = node.data.IsReadAccess ? "Read" : node.data.IsReadOrWriteAccess ? "ReadWrite" : "NoAccess";
        flattenedData.push({
          UserId: node.data.UserId,
          ConfigurationId: node.data.ConfigurationName?.ConfigurationId ?? node.data.ConfigurationId,
          Assembly: assembly.AssemblyName,
          AccessType: accessType
        });
      });
    });
    const seen = new Set();
    for (const entry of flattenedData) {
      const key = `${entry.UserId}|${entry.ConfigurationId}|${entry.Assembly}`;
      if (seen.has(key)) {
        return true;
      }
      seen.add(key);
    }
    return false;
  }

  submit(event?: any) {
    if (!this.hasUnsavedChanges && event == undefined) {
      if (this.fromPage === 'ProjectPage') {
        this.router.navigate(["/tc-project"])
      } else if (this.fromPage === 'Configuration') {
        this.router.navigate(["/tc-configuration"])
      } else {
        this.router.navigate(["/tc-project"])
      }
      return true;
    }
    let errorMessage = messages.cellEmptyErrorMesssage;
    let checkbox = messages.AccessCheckbox;
    let error = [];
    let lastRow = this.gridApi.getDisplayedRowAtIndex(this.gridApi.getDisplayedRowCount() - 1);

    if (lastRow != undefined) {
      let data = lastRow.data;

      if (data.UserName == "" || data.UserName == "Add Name" || data.UserName == null) {
        error.push({ Teams: errorMessage })
      }
      if (data.OrgCode == "" || data.OrgCode == undefined || data.OrgCode == null) {
        error.push({ OrgCode: errorMessage })
      }
      if (data.IsReadAccess == null && data.IsReadOrWriteAccess == null) {
        error.push({ ReadOnly: checkbox })
        error.push({ IsReadOrWriteAccess: checkbox })
      }
      if (data.ConfigurationName == " " || data.ConfigurationName == null) {
        error.push({ Configuration: errorMessage })
      }
      if (data.Assemblies == " " || data.Assemblies == null) {
        error.push({ AssemblyGroup: errorMessage })
      }
    }
    if (error.length != 0) {
      this.openAlertDialog(error);
      return false;
    }
    else {
      let response = null;
      this.showGrid = false;
      this.submitted = true;
      if (this.hasDuplicateAccess()) {
        this.openAlertDialog([{ Duplicate: messages.DuplicateAccess }]);
        this.showGrid = true;
        this.submitted = false;
        return false;
      }

      let sendData: any = this.sendData();
      response = this.configurationService.InsertUpdateTCAuthorizationAccess(sendData).toPromise().
        then((res) => {
          this.showGrid = true;
          this.submitResponse = res;
          let successCode = this.submitResponse.StatusCode;
          let errorCode = this.submitResponse.Data.ErrorCode;
          let errorMsgeFromBack = this.submitResponse.Data.Message;
          if (successCode == 200) {
            if (errorCode == 0) {

              if (event != undefined && event.route === '/tc-manageProject') {
                this.localStorageService.set("ConfigId", null);
                this.sharedService.changeConfigId(0);
              }

              this.hasUnsavedChanges = false;
              let dataSaveMessage = serverMessage.dataSaveMessage;
              this.toast.notify(dataSaveMessage, "success");
              // this.loadData();
              this.router.navigate(["/tc-configuration"])

              if (event != undefined) {
                this.localStorageService.remove("configuration");
                this.hasUnsavedChanges = false;
                this.router.navigate(['/tc-manageProject'])
              }
              return true;
            }
            else {
              //Show errorCode and errorMessage in the UI
              let errorContainer = [
                { [serverMessage.serverNotSaveMessage]: serverMessage.serverErrorHeader },
                { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
              ]
              this.openAlertDialog(errorContainer)
              this.submitted = false;
              return false;
            }
          }
          else {
            let errorContainer = [
              { [serverMessage.serverNotSaveMessage]: serverMessage.serverErrorHeader },
              { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
            ]
            this.openAlertDialog(errorContainer)
            this.submitted = false;
            return false;
          }
        },
          (error) => {
            this.submitted = false;
            this.openAlertDialog([{ [serverMessage.serverAPIerror]: serverMessage.serverErrorHeader }])
            return false;
          })

      return response;
    }
  }

  sendData() {
    let dataToSend = [];
    let hasRows = false;
    this.gridApi.forEachNode(node => {
      hasRows = true;
      //  if (node.data.Id == 0 && node.data.Name != "Add Title") {
      this.hasUnsavedChanges = true;
      // dataToSend.push(node.data);
      let dto: tcAuthorizationAccess = new tcAuthorizationAccess();
      //  dto.Id = 0;
      dto.ProjectId = this.projectId;
      dto.UserId = node.data.UserId;
      dto.IsReadAccess = node.data.IsReadAccess || false;
      dto.IsReadOrWriteAccess = node.data.IsReadOrWriteAccess || false;
      dto.ConfigurationId = node.data.ConfigurationName?.ConfigurationId ?? node.data.ConfigurationId;
      dto.Assemblies = node.data.Assemblies || [];
      dto.BusinessAreaId = this.businessAreaId;
      dto.BusinessLineId = this.businessLineId;
      dto.CreatedBy = this.userInOrg.UserId;
      dataToSend.push(dto);
      //   }
    })
    let lstConfiguration = [];

    if (!hasRows) {
      let dto: tcAuthorizationAccess = new tcAuthorizationAccess();
      dto.ProjectId = this.projectId;
      dto.UserId = 0;
      dto.IsReadAccess = false;
      dto.IsReadOrWriteAccess = false;
      dto.ConfigurationId = 0;
      dto.Assemblies = [];
      dto.BusinessAreaId = this.businessAreaId;
      dto.BusinessLineId = this.businessLineId;
      dto.CreatedBy = this.userInOrg?.UserId;
      dataToSend.push(dto);
    }
    // this.modifiedConfigurationRows.forEach(item => {
    //   if (item.Id != 0) {
    //     let dto: tcAuthorizationAccess = new tcAuthorizationAccess();
    //     dto.Id = item.Id;
    //     dto.ProjectId = this.projectId;
    //     dto.UserId = item.UserId;
    //     dto.IsReadAccess = item.IsReadAccess;
    //     dto.IsReadOrWriteAccess = item.IsReadOrWriteAccess;
    //     dto.ConfigurationId = item.ConfigurationName;
    //     dto.Assemblies =  item.Assemblies || [];
    //     dto.BusinessAreaId = this.businessAreaId;
    //     dto.BusinessLineId = this.businessLineId;
    //     dto.CreatedBy = this.userInOrg.UserId;
    //     lstConfiguration.push(dto);
    //   }
    // });
    dataToSend = dataToSend.concat(lstConfiguration);
    return dataToSend;
  }
}

function dropdownTextRenderer(params: ICellRendererParams) {
  //const selectedIds = params.value;
  // const selectedTexts: any;
  const selectedIds = params.node.data.ConfigurationName?.ConfigurationName;
  if (selectedIds == undefined) {
    const selectedId = params.node.data.ConfigurationName;
    return selectedId;
  }
  else
    return selectedIds;
}
function AssemblydropdownTextRenderer(params: ICellRendererParams) {
  const selectedIds = params.data.Assemblies;
  // const selectedTexts: any;
  // if(params.value!=undefined)
  // {
  const selectedTexts = selectedIds?.map(obj => obj.AssemblyName).join(', ');


  return selectedTexts;
  // }
}
